module.exports = __webpack_public_path__ + "static/img/ximena-llaguno.a46dc41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ximena-llaguno.jpg
// module id = A/X6
// module chunks = 0